query GetSageSalesforceMetric(
  $metricType: SageSalesforceMetricTypeEnum!
  $id: ID
  $forMonth: ISO8601Date
) {
  sageSalesforceMetric(metricType: $metricType, id: $id, forMonth: $forMonth) {
    metricType
    otherValue
    value
  }
}
